type Value = {
  idToken: string;
  clientId: string;
  lineActivationProviderId: string;
};

class LiffConfigManager {
  private value: Value | undefined;

  getValue(): Value | undefined {
    return this.value;
  }

  setValue(v: Value): void {
    this.value = v;
  }
}

// plugin からも呼ばれるので、素朴に Vue コンポーネントに依存しないシングルトンとして状態を管理する
// plugin から provide して Vue コンポーネントから inject することもできるがここでは素朴な方法を選んだ
export const liffConfigManager = new LiffConfigManager();
